import { Typography, Box, Divider } from "@mui/material"
import Symptoms from "./Symptoms"
import Diagnostics from "./Diagnostics"
import Specialists from "./Specialists"
import useTranslation from "../../../hooks/use_translation"

const DiseaseDescription = ({ disease }) => {
  const { anamnesis } = useTranslation()

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
        {disease?.name}
      </Typography>
      <Divider />

      <Box sx={{ my: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {anamnesis?.disease_card_desc}
        </Typography>
        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: disease?.description }} />
      </Box>

      <Symptoms data={disease?.symptoms || []} />

      <Diagnostics data={disease?.diagnostics || []} />

      <Box sx={{ my: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {anamnesis?.disease_card_treatment}
        </Typography>
        <Typography
          sx={{ ul: { ml: -2, mb: 4 } }}
          variant="body1"
          dangerouslySetInnerHTML={{ __html: disease?.treatment }}
        />
      </Box>

      <Specialists data={disease?.specialists || []} />
    </Box>
  )
}

export default DiseaseDescription
